
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

// Helper function to shuffle an array
const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [animatedCovers, setAnimatedCovers] = useState([]);

  useEffect(() => {
    fetch('https://backend.viralphonks.com:443/songs')
      .then(response => response.json())
      .then(data => {
        const selectedSongs = shuffleArray(data).slice(0, 8);
        const placedPositions = [];
        const minDistance = 20; // Minimum distance in vh/vw units
        const centralNoGoZone = { top: 25, bottom: 75, left: 25, right: 75 };

        const covers = selectedSongs.map(song => {
          let position = {};
          let isValidPosition = false;
          let attempts = 0;

          while (!isValidPosition && attempts < 100) {
            isValidPosition = true;
            position = {
              top: Math.random() * 85 + 5, // 5vh to 90vh
              left: Math.random() * 85 + 5, // 5vw to 90vw
            };

            // Check if it's in the central no-go zone
            if (position.top > centralNoGoZone.top && position.top < centralNoGoZone.bottom &&
                position.left > centralNoGoZone.left && position.left < centralNoGoZone.right) {
              isValidPosition = false;
              attempts++;
              continue;
            }

            // Check for collisions with already placed covers
            for (const p of placedPositions) {
              const dist = Math.sqrt(Math.pow(p.top - position.top, 2) + Math.pow(p.left - position.left, 2));
              if (dist < minDistance) {
                isValidPosition = false;
                break;
              }
            }
            attempts++;
          }

          if (isValidPosition) {
              placedPositions.push(position);
          }

          return {
            id: song.id,
            imageUrl: song.cover_image_url,
            style: {
              top: `${position.top}vh`,
              left: `${position.left}vw`,
              animationDuration: `${Math.random() * 10 + 15}s`,
              animationDelay: `-${Math.random() * 5}s`,
            }
          };
        });

        setAnimatedCovers(covers);
      })
      .catch(error => console.error('Error fetching songs for background:', error));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://backend.viralphonks.com:443/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/admin');
      } else {
        alert(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred during login.');
    }
  };

  return (
    <div className="about-container">
      <div className="background-animation">
        {animatedCovers.map(cover => (
          <div key={cover.id} className="floating-cover" style={cover.style}>
            <img src={cover.imageUrl} alt="" />
          </div>
        ))}
      </div>
      <div className="about-content">
        <div className="about-box">
          <h1>Admin Login</h1>
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ marginLeft: '-8px' }}
            />
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
